import Swiper, { Keyboard, Navigation, EffectFade } from 'swiper'

// # main function
sliders()
function sliders() {
  addClassSwiper()

  if (document.querySelector('.slider-news')) {
    new Swiper('.slider-news', {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 20,
      slidesPerView: 'auto',
      watchOverflow: true,

      modules: [Navigation, Keyboard],

      navigation: {
        nextEl: '.slider-news__btn_right',
        prevEl: '.slider-news__btn_left',
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {
        1679.98: {
          spaceBetween: 30,
        },
      },
    })
  }
  if (document.querySelector('.slider-solution')) {
    new Swiper('.slider-solution', {
      direction: 'horizontal',
      effect: 'fade',
      loop: true,
      speed: 800,
      spaceBetween: 0,
      slidesPerView: 1,
      watchOverflow: true,

      modules: [Navigation, Keyboard, EffectFade],

      navigation: {
        nextEl: '.slider-solution__btn_right',
        prevEl: '.slider-solution__btn_left',
      },

      fadeEffect: {
        crossFade: true,
      },

      keyboard: {
        enabled: true,
      },
    })
  }
}

//# addClassSwiper
function addClassSwiper() {
  const $sliders = document.querySelectorAll('[class*="__swiper"]')

  $sliders.forEach(slider => {
    slider = slider.parentElement
    const wrapper = slider.children[0]
    const slides = Array.from(wrapper.children)

    slider.classList.add('swiper')
    wrapper.classList.add('swiper-wrapper')
    slides.forEach(addClassSlide)
  })
}

//# addClassSlide
function addClassSlide(slide) {
  slide.classList.add('swiper-slide')
}
